export default "__VITE_ASSET__DY2IRX5Q__"